var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandTequila(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0182 11.213H27.5892V7.4589C28.3089 7.36703 28.8656 6.75377 28.8656 6.00915V1.96292C28.8656 1.155 28.2106 0.5 27.4026 0.5H18.5974C17.7895 0.5 17.1345 1.155 17.1345 1.96292V6.00915C17.1345 6.75377 17.6913 7.36713 18.411 7.4589V11.213H11.9818C11.1739 11.213 10.5189 11.868 10.5189 12.676V44.0371C10.5189 44.845 11.1739 45.5 11.9818 45.5H34.0182C34.8262 45.5 35.4812 44.845 35.4812 44.0371V12.676C35.4812 11.868 34.8262 11.213 34.0182 11.213ZM29.659 36.894C29.659 37.7019 29.004 38.3569 28.1961 38.3569H17.8039C16.9959 38.3569 16.3409 37.7019 16.3409 36.894V24.0504C16.3409 23.2425 16.9959 22.5875 17.8039 22.5875H28.1962C29.0041 22.5875 29.6591 23.2425 29.6591 24.0504V36.894H29.659Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandTequila);
export default __webpack_public_path__ + "static/media/brandTequila.3e4f6fb5545ca1a70be42a0b29ee63ca.svg";
export { ForwardRef as ReactComponent };